import { fabric } from 'fabric';
import CollaborationBehaviors from './CollaborationBehaviors';
import ShapeBase from '../shapes/ShapeBase';
import AnalyticsBehaviors from './AnalyticsBehaviors';
import ReadOnlyBehaviors from './ReadOnlyBehaviors';
import FrameMemberBehaviors from './FrameMemberBehaviors';
import { lookupNativeEmoji } from '../utils/emoji';
import LockBehaviors from './LockBehaviors';

const defaultControls = fabric.Object.prototype.controls;

const STAMP_DEFAULT_SIZE = 30;
const EMOJI_FONT_SIZE = 500;

// An emoji "stamped" onto the canvas. This is the original stamp that used
// emojis as opposed to the new SvgStamp which uses our own images. This is
// maintained so we can continue to render the old emojis on whiteboards that
// already had them.
interface Stamp
  extends fabric.Object,
    LockBehaviors,
    ReadOnlyBehaviors,
    CollaborationBehaviors,
    FrameMemberBehaviors {}

@LockBehaviors
@AnalyticsBehaviors
@ReadOnlyBehaviors
@CollaborationBehaviors
@FrameMemberBehaviors
class Stamp extends fabric.Object {
  type = 'stamp';
  noScaleCache = false;
  // So edges are sharp on large objects at high scales
  objectCaching = false;

  emoji: string;
  svg: string;

  uniformScaling = true;
  snapAngle = 45;
  snapThreshold = 5;

  // Simple controls for stamps.
  controls = {
    tl: defaultControls.tl,
    tr: defaultControls.tr,
    bl: defaultControls.bl,
    br: defaultControls.br,
    mtr: ShapeBase.rotateControl(),
  };

  // Keys that will be serialized for saving and sending to remote systems.
  serializedKeys = [
    'z',
    'left',
    'top',
    'scaleX',
    'scaleY',
    'angle',
    'container',
    'emoji',
  ];

  nativeEmoji: string;

  constructor(options) {
    super({
      ...options,
      width: STAMP_DEFAULT_SIZE,
      height: STAMP_DEFAULT_SIZE,
      angle: options.angle || Stamp._randomRotation(),
      emoji: options.emoji || ':+1:',
    });
    this.nativeEmoji = lookupNativeEmoji(this.emoji);
    this.initializeFrameMember();
    this.initializeLockBehaviors(options.locked);
  }

  static _randomRotation() {
    const offset = 20;
    return Math.random() * (2 * offset) - offset;
  }

  _render(ctx) {
    ctx.font = `${EMOJI_FONT_SIZE}px serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.scale(this.width / EMOJI_FONT_SIZE, this.height / EMOJI_FONT_SIZE);
    ctx.fillText(this.nativeEmoji, 0, 70);
  }
}

export { Stamp as default, STAMP_DEFAULT_SIZE };
